/**
 * Normaliza un nombre para busqueda instantanea: minusculas, sin acentos,
 * sin signos, espacios colapsados. Se guarda en `invitacion.nombreNormalizado`
 * y se usa tambien para la coincidencia exacta de /api/mesa.
 */
export function normalizarNombre(valor) {
    return valor
        .normalize('NFD')
        .replace(/\p{M}/gu, '') // quita diacriticos combinantes
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}
/** Ultimos 4 digitos de un telefono (ignora espacios, guiones, parentesis, +). */
export function ultimos4(telefono) {
    const soloDigitos = telefono.replace(/\D/g, '');
    return soloDigitos.slice(-4);
}
/** true si el string tiene exactamente 4 digitos. */
export function esUlt4Valido(valor) {
    return /^\d{4}$/.test(valor);
}
//# sourceMappingURL=normalize.js.map